import * as React from 'react';
import style from './tabs-panel.scss';

const TabsPanelComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (<div className={style.tabsPanel}>
    {children}
  </div>);
};

export const TabsPanel = TabsPanelComponent;
